import { render, staticRenderFns } from "./ArtikelEdit.vue?vue&type=template&id=f5cec532&scoped=true"
import script from "./ArtikelEdit.vue?vue&type=script&lang=ts"
export * from "./ArtikelEdit.vue?vue&type=script&lang=ts"
import style0 from "./ArtikelEdit.vue?vue&type=style&index=0&id=f5cec532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cec532",
  null
  
)

export default component.exports